import { Button, Modal } from "antd";
import React, { useState } from "react";
import EndPointForm from "./EndPointsForm";
import { IoMdClose } from "react-icons/io";

// Define the types for props
interface EndPointsModalProps {
  linkType: string;
  linkModalOpen: boolean;
  handleLinkClose: () => void;
  id: { id: string; name: string } | string; // Adjust based on the actual shape of `id`
  handleSubmit: (e: React.FormEvent) => void; // Updated type
  actionItem: any; // Define more specific type based on actual structure
  actionType: string;
}

const EndPointsModal: React.FC<EndPointsModalProps> = ({
  linkType,
  linkModalOpen,
  handleLinkClose,
  id,
  handleSubmit,
  actionItem,
  actionType,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width={500}
      open={linkModalOpen}
      onCancel={handleLinkClose}
      title={
        linkType === "link_component" ? "Link Endpoint To Page Component" : ""
      }
      footer={
        <>
          <Button onClick={handleLinkClose} danger>
            Close
          </Button>
          <Button
            form="link_form"
            htmlType="submit"
            type="primary"
            onClick={handleSubmit}
            loading={loading}
          >
            Link
          </Button>
        </>
      }
    >
      <EndPointForm
        getId={
          typeof id === "string" ? { id, name: "" } : id || { id: "", name: "" }
        }
        linkType={linkType}
        setLoading={setLoading}
        actionItem={actionItem}
        close={handleLinkClose}
        actionType={actionType}
      />
    </Modal>
  );
};

export default EndPointsModal;
